import { RouteType } from "../../../types/RouteType";

const PlantInventoryCheckWorkflowRoute: RouteType = {
  name: "Plant Inventory Check",
  path: "/workflows/plant-inventory-check",
  layout: "/app",
  requiresAuth: true,
  viewportCard: {
    header: {
      component: () => import("./PlantInventoryCheckWorkflowHeader"),
      title: "Check Plant Inventory",
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./PlantInventoryCheckWorkflow"),
      grayBackground: true,
    },
  },
  requiresPermission: false,
  beforeEnter: async () => {
    return true;
  },
};

export default PlantInventoryCheckWorkflowRoute;
